export const DEFAULT_YEAR = '2024'
